import React, { createContext, useContext, useState, useEffect } from "react";
import { apiLogin, apiMe } from "../services/api";
import { clearBrandingCache, getBranding } from "../ujms/branding";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("odyssey_token");
    const stored = localStorage.getItem("odyssey_user");
    if (token && stored) {
      try {
        setUser(JSON.parse(stored));
      } catch (e) {
        localStorage.removeItem("odyssey_user");
      }
      // validate token in background
      apiMe()
        .then((res) => {
          setUser(res.data);
          localStorage.setItem("odyssey_user", JSON.stringify(res.data));
        })
        .catch(() => {
          localStorage.removeItem("odyssey_token");
          localStorage.removeItem("odyssey_user");
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    try {
      const res = await apiLogin(username.toLowerCase(), password);
      const { token, user: u } = res.data;
      localStorage.setItem("odyssey_token", token);
      localStorage.setItem("odyssey_user", JSON.stringify(u));
      clearBrandingCache();
      getBranding(true).catch(() => {});
      setUser(u);
      return { success: true, user: u };
    } catch (err) {
      return { success: false, error: err.response?.data?.detail || "Login failed. Please try again." };
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("odyssey_token");
    localStorage.removeItem("odyssey_user");
    clearBrandingCache();
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
